import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import AuthService from "services/AuthService"

export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await AuthService.getProfile()

      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (formData, thunkAPI) => {
    try {
      const response = await AuthService.updateProfile(formData)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const updateRecomponse = createAsyncThunk(
  "profile/updateRecompnse",
  async (data, thunkAPI) => {
    try {
      const response = await AuthService.updateRecomponse(data)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    data: null,
    loading: false,
    error: null,
    recomponse: {
      data: null,
      loading: false,
      error: null,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(updateProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(updateRecomponse.pending, (state) => {
        state.recomponse.loading = true
        state.recomponse.error = null
      })
      .addCase(updateRecomponse.fulfilled, (state, action) => {
        state.recomponse.loading = false
        state.recomponse.data = action.payload
      })
      .addCase(updateRecomponse.rejected, (state, action) => {
        state.recomponse.loading = false
        state.recomponse.error = action.payload
      })
  },
})

export default profileSlice.reducer
